<div class="p-grid">
	<H1>Test</H1>
</div>


<!-- <input-p
	[inputField] = "inputFields[0]"
	(eventEmitter) = "executeAction($event)"
	(keydown.enter)="test1()">
</input-p> -->



<input type="text" tabindex="-1"
placeholder="com inputmode"
inputmode="text"
#input
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>

<input type="text" tabindex="-1"
placeholder="com inputmode"
inputmode="numeric"
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>

<input type="text" tabindex="-1"
placeholder="com inputmode"
inputmode="text"
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>

<input type="text" tabindex="-1"
placeholder="com inputmode"
inputmode="numeric"
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>

<hr>


<input type="text" tabindex="-1"
placeholder="Sem inputmode com text"
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>

<input type="number"  min="1" maxlength="16" tabindex="-1"
placeholder="Sem inputmode com number"
(keydown.enter)="enableGboard()"
(keydown.tab)="enableGboard()"
>




